import { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'
import convertKeys from 'utils/convert-keys'
import { ENDPOINTS } from './constants'

const fetchTremendousRedemptionOptions = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(ENDPOINTS.TREMENDOUS_REDEMPTION_OPTIONS)
  return convertKeys.toCamel(response.data)
}

const fetchCryptoRedemptionOptions = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(ENDPOINTS.CRYPTO_REDEMPTION_OPTIONS)
  return convertKeys.toCamel(response.data)
}

const requestTremendousRedemption = async (amount, destination, recaptchaToken, ipAddress) => {
  const token = await getToken()
  const payload = {
    amount,
    destination,
    recaptcha_token: recaptchaToken,
    ip_address: ipAddress,
  }
  await cognitoAxiosInstance(token).post(ENDPOINTS.TREMENDOUS_REDEMPTION, payload)
}

const requestExternalRedemption = async (amount, destination, recaptchaToken, ipAddress) => {
  const token = await getToken()
  const payload = {
    amount,
    destination,
    recaptcha_token: recaptchaToken,
    ip_address: ipAddress,
  }
  await cognitoAxiosInstance(token).post(ENDPOINTS.EXTERNAL_REDEMPTION, payload)
}

const requestSharesRedemption = async (amount, recaptchaToken, ipAddress) => {
  const token = await getToken()
  const payload = {
    number_of_shares: amount,
    recaptcha_token: recaptchaToken,
    ip_address: ipAddress,
  }
  const response = await cognitoAxiosInstance(token).post(ENDPOINTS.SHARES_REDEMPTION, payload)
  return convertKeys.toCamel(response.data)
}

const requestCryptoRedemptionQuote = async (crypto) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).post(ENDPOINTS.CRYPTO_REDEMPTION_QUOTE, { crypto })
  return convertKeys.toCamel(response.data)
}

const requestCryptoRedemption = async (requestPayload) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).post(ENDPOINTS.CRYPTO_REDEMPTION, requestPayload)
  return convertKeys.toCamel(response.data)
}

export default {
  fetchTremendousRedemptionOptions,
  fetchCryptoRedemptionOptions,
  requestCryptoRedemptionQuote,
  requestCryptoRedemption,
  requestTremendousRedemption,
  requestExternalRedemption,
  requestSharesRedemption,
}
